import { Fragment } from "react";
import {
  Card,
  CardMedia,
  Divider,
  Grid,
  InputAdornment,
  List,
  ListItem,
  ListItemText,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

import Gobutton from "../../../../components/Gobutton";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import LaptopMacIcon from "@mui/icons-material/LaptopMac";
import FactoryIcon from "@mui/icons-material/Factory";
import InfoIcon from "@mui/icons-material/Info";
import IconButton from "@mui/material/IconButton";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import ImageUpload from "../../../../components/ImageUpload";
import { ReactComponent as TulipWhiteLibrary } from "../../../../svgs/tulipLibraryWhite.svg";
import { ReactComponent as TulipLibrary } from "../../../../svgs/tulipLibrary.svg";
import SvgIcon from "@mui/material/SvgIcon";
import PDFUpload from "../../../../components/PDFUpload";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

const style = {
  p: 0,
  width: "100%",
  borderRadius: 2,
  border: "1px solid",
  borderColor: "divider",
  backgroundColor: "#FFF",
  fontSize: "6px",
};

function isVideoUrl(url) {
  if (!url) return false;
  const lower = url.toLowerCase();
  return (
    lower.includes(".mp4") || lower.includes(".webm") ||
    lower.includes(".mov") || lower.includes(".mkv") ||
    lower.includes("youtube.com") || lower.includes("youtu.be") ||
    lower.includes("wistia.com") || lower.includes("vimeo.com")
  );
}

export default function FactoryFeatures({ asset, setAsset }) {
  function handleChange(event) {
    const newAsset = { ...asset, [event.target.id]: event.target.value };
    setAsset(newAsset);
  }

  const handleNewFeature = () => {
    const newFeatures = [...asset.Features, ""];
    const newAsset = { ...asset, Features: newFeatures };
    setAsset(newAsset);
  };
  const handleFileUploadChange = (file) => {
    const newAsset = { ...asset, img: file };
    setAsset(newAsset);
  };

  const handlePDFUploadChange = (file) => {
    const newAsset = { ...asset, pdf: file };
    setAsset(newAsset);
  }

  return (
    <Grid container sx={{ flexDirection: "row", gap: 3 }} className="lg:!flex-nowrap">
      <Grid
        item
        xs={12}
        sm={7}
        sx={{ justifyContent: "center", alignItems: "center" }}
      >
        <Grid
          item
          xs
          sx={{ backgroundColor: "background.default" }}
          marginY={"auto"}
          borderRadius={"0px 8px 8px 8px"}
          padding={3}
        >
          <Grid container gap={2}>
            <Grid item xs={12}>
              <Typography color={"customColors.default"} variant="h8">
                {asset.Title}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} alignItems={"center"}>
              <Card sx={{ boxShadow: "none", backgroundColor: "transparent" }}>
                {isVideoUrl(asset.img) ? (
                  <video
                    src={asset.img}
                    autoPlay
                    loop
                    muted
                    playsInline
                    style={{
                      boxShadow: "none",
                      maxWidth: "100%",
                      maxHeight: "80vh",
                      objectFit: "cover",
                      objectPosition: "center",
                    }}
                  />
                ) : (
                  <CardMedia
                    component="img"
                    image={asset.img}
                    style={{
                      boxShadow: "none",
                      maxWidth: "100%",
                      maxHeight: "80vh",
                      objectFit: "cover",
                      objectPosition: "center",
                    }}
                  />
                )}
              </Card>
            </Grid>
            <Grid item xs>
              <Typography fontSize={"small"} color={"customColors.default"}>
                Key Features
              </Typography>
              {asset.Features && asset.Features[0] !== "" && (
                <List aria-label="mailbox folders" sx={style}>
                  {asset.Features.map((feature, index) => (
                    <Fragment key={index}>
                      <ListItem>
                        <ListItemText
                          sx={{ color: "customColors.defaultLight" }}
                          primary={feature}
                        />
                      </ListItem>
                      {index < asset.Features.length - 1 && (
                        <Divider component="li" />
                      )}
                    </Fragment>
                  ))}
                </List>
              )}
            </Grid>
            <Grid
              container
              justifyContent={"right"}
              alignItems={"bottom"}
              gap={1}
            >
              {asset.appUrl && (
                <Gobutton
                  text={"Open the App"}
                  startIcon={<ExitToAppIcon />}
                  url={{ type: "beacon", url: asset.appUrl }}
                />
              )}
              {asset.editorUrl && (
                <Gobutton
                  text={"Open the Editor"}
                  startIcon={<LaptopMacIcon />}
                  url={{ type: "beacon", url: asset.editorUrl }}
                />
              )}
              {asset.contentUrl && (
                <Gobutton
                  text={"More info"}
                  startIcon={<InfoIcon />}
                  url={{ type: "content", url: asset.contentUrl }}
                />
              )}
              {asset.video && (
                <Gobutton
                  text={"Play the Video"}
                  startIcon={<InfoIcon />}
                  url={{ type: "video", url: asset.video }}
                />
              )}
              {asset.pdf && (
                <Gobutton
                  text={"Open Demo Guide"}
                  startIcon={<PictureAsPdfIcon />}
                  url={{ type: "beacon", url: asset.pdf }}
                />
              )}
              {asset.tulipLibrary && (
                <Gobutton
                  text={"Open in Tulip Library"}
                  startIcon={
                    <SvgIcon
                      className="tulipLibrary"
                      inheritViewBox
                      sx={{
                        height: "18px",
                        width: "auto",
                        // color: "customColors.white",
                      }}
                      component={TulipWhiteLibrary}
                    />
                  }
                  url={{ type: "beacon", url: asset.tulipLibrary }}
                />
              )}
              {asset.Type === "factory" && (
                <Gobutton
                  text={"Explore the Factory"}
                  startIcon={<FactoryIcon />}
                  url={"factory"}
                />
              )}
              {asset.Type === "megafactory" && (
                <Gobutton
                  text={"Explore the Factory"}
                  startIcon={<FactoryIcon />}
                  url={"megafactory"}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs>
        <Stack direction={"column"} gap={2}>
          <ImageUpload value={asset.img} onChange={handleFileUploadChange} acceptVideo />
          <PDFUpload value={asset.pdf} onChange={handlePDFUploadChange} />

          <TextField
            id="desc"
            label="Verbose Description"
            fullWidth
            value={asset.desc}
            onChange={(event) => {
              handleChange(event);
            }}
          />

          <TextField
            id="tulipLibrary"
            label="Open in Tulip Library"
            fullWidth
            value={asset.tulipLibrary}
            onChange={(event) => {
              handleChange(event);
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SvgIcon
                    inheritViewBox
                    sx={{
                      height: "18px",
                      width: "auto",
                      color: "customColors.black",
                    }}
                    component={TulipLibrary}
                  />
                </InputAdornment>
              ),
            }}
          />

          <Stack direction={"column"} gap={2} width={"100%"}>
            <Typography>Features</Typography>
            {asset.Features.length > 0 &&
              asset.Features.map((feature, thisIndex) => (
                <Stack key={thisIndex} direction={"row"}>
                  <IconButton
                    aria-label="delete"
                    xs
                    onClick={() => {
                      const newFeatures = asset.Features.filter(
                        (item, index) => index !== thisIndex
                      );
                      setAsset({ ...asset, Features: newFeatures });
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                  <TextField
                    key={`feature-${thisIndex}`}
                    size="small"
                    sx={{ width: "100%" }}
                    id={`feature-${thisIndex}`}
                    value={feature}
                    onChange={(e) => {
                      const updatedItems = [...asset.Features];
                      updatedItems[thisIndex] = e.target.value;
                      setAsset({ ...asset, Features: updatedItems });
                    }}
                  />
                </Stack>
              ))}
            <Grid container>
              <Grid item xs>
                <IconButton
                  aria-label="delete"
                  xs
                  onClick={(event) => {
                    handleNewFeature(event);
                  }}
                >
                  <AddCircleIcon />
                </IconButton>
              </Grid>
            </Grid>
          </Stack>
        </Stack>
      </Grid>
    </Grid>
  );
}
